import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { hideField } from '../../shared/forms/constants';

import { requiredWithFlagInContext, differentThan } from '../../shared/forms/validators';

import ReadOnlyAmountFormik from './readOnlyAmountFormik.component';

const valueGetterFactory = (option, options) => ({ formik, formContext }) => {
  if (!formik.values[option]) {
    return '';
  }

  const foundOption = formContext[options]
    && formContext[options].find(({ value }) => value === formik.values[option]);

  return foundOption ? foundOption.label : '';
};

const toCompanyCodeValueGetter = valueGetterFactory('companyCode', 'companyCodes');
const toCountryTaxTypeValueGetter = valueGetterFactory('countryTaxType', 'countryTaxTypes');
const toEntryTypeValueGetter = valueGetterFactory('entryType', 'entryTypes');
const toEntryActivityValueGetter = valueGetterFactory('entryActivity', 'entryActivities');
const toBookTypeValueGetter = valueGetterFactory('bookType', 'bookTypes');
const toAccountValueGetter = valueGetterFactory('account', 'accounts');

const toAmountValueGetter = ({ formik }) => ({
  net: (formik.values.amount.net * -1).toFixed(2),
  gross: (formik.values.amount.gross * -1).toFixed(2),
});

const conditions = [{
  when: ({ formContext }) => !formContext.isReclassBalances,
  then: hideField,
}];

const schema = [
  {
    name: 'toCompanyCode',
    component: InputFormik,
    meta: { label: 'To Company Code', valueGetter: toCompanyCodeValueGetter },
    options: { readOnly: true },
    additionalProps: { disabled: true, handleExternalChange: true, className: 'middle-column transparent' },
    conditions,
  },
  {
    name: 'toTaxYear',
    component: SelectFormik,
    meta: { label: 'To Tax Year', optionsKey: 'taxYears' },
    options: { yupType: yupString(), validationRules: [
      requiredWithFlagInContext('isReclassBalances'),
      differentThan('taxYear', 'Tax Year', 'allowFromAccount'),
    ] },
    additionalProps: { required: true, virtualized: true, className: 'middle-column' },
    conditions: [
      ...conditions,
      {
        when: ({ formContext, formik }) =>
          formContext.tbeErrors.find(tbeError => tbeError.companyCode === formik.values.companyCode),
        then: { additionalProps: { disabled: true } },
      },
    ],
  },
  {
    name: 'toCountryTaxType',
    component: InputFormik,
    meta: { label: 'To Country Tax Type', valueGetter: toCountryTaxTypeValueGetter },
    options: { readOnly: true },
    additionalProps: { disabled: true, handleExternalChange: true, className: 'middle-column transparent' },
    conditions,
  },
  {
    name: 'toEntryType',
    component: InputFormik,
    meta: { label: 'To Entry Type', valueGetter: toEntryTypeValueGetter },
    options: { readOnly: true },
    additionalProps: { disabled: true, handleExternalChange: true, className: 'middle-column transparent' },
    conditions,
  },
  {
    name: 'toEntryActivity',
    component: InputFormik,
    meta: { label: 'To Entry Activity', valueGetter: toEntryActivityValueGetter },
    options: { readOnly: true },
    additionalProps: { disabled: true, handleExternalChange: true, className: 'middle-column transparent' },
    conditions,
  },
  {
    name: 'toBookType',
    component: InputFormik,
    meta: { label: 'To Book Type', valueGetter: toBookTypeValueGetter },
    options: { readOnly: true },
    additionalProps: { disabled: true, handleExternalChange: true, className: 'middle-column transparent' },
    conditions,
  },
  {
    name: 'toAccount',
    component: SelectFormik,
    meta: { label: 'To Account', optionsKey: 'accounts' },
    options: { yupType: yupString(), validationRules: [
      requiredWithFlagInContext(['allowFromAccount', 'isReclassBalances']),
      differentThan('account', 'Account'),
    ] },
    additionalProps: { required: true, virtualized: true, className: 'middle-column' },
    conditions: [
      ...conditions,
      {
        when: ({ formContext }) => !formContext.combination.requireAccount,
        then: hideField,
      },
      {
        when: ({ formContext }) => formContext.combination.allowFromAccount,
        then: { additionalProps: { required: true } },
        otherwise: {
          component: InputFormik,
          meta: { optionsKey: null, valueGetter: toAccountValueGetter },
          additionalProps: { disabled: true, className: 'middle-column transparent' },
        },
      },
    ],
  },
  {
    name: 'toAmount',
    component: ReadOnlyAmountFormik,
    meta: { valueGetter: toAmountValueGetter },
    options: { readOnly: true },
    additionalProps: ({
      currencyCode,
      combination,
    }) => ({
      className: 'middle-column transparent',
      suffix: currencyCode,
      allowGross: combination.allowGross,
    }),
    conditions: [{
      when: ({ formContext }) => !formContext.isReclassBalances,
      then: {
        meta: { valueGetter: () => ({ net: '', gross: '' }) },
        additionalProps: { hidden: true },
      },
    }],
  },
];

export default schema;
